import { createMuiTheme, fade } from '@material-ui/core';

const colors = {
  alabaster: '#fafafa',
  alto: '#d8d8d8',
  black: '#000000',
  chalky: '#ecd898',
  chatelle: '#b3b0c4',
  chromeWhite: '#e1efce',
  doveGray: '#666666',
  earlsGreen: '#a9c23f',
  edgewater: '#b9dcd2',
  greenSpring: '#bac5b9',
  mineShaft: '#333333',
  newOrleans: '#f0bf9b',
  oxfordBlue: '#3C4858',
  pigeonPost: '#a7bcd6',
  seance: '#9c27b0',
  shiraz: '#c00d1e',
  silver: '#c0c0c0',
  tacha: '#bbd05e',
  white: '#ffffff',
  wildSand: '#f5f5f5',
  facebook: '#3B5998',
  vkontakte: '#44668f',
  google: '#dd4630',
  wechat: '#7bb32e',
  primary: '#000000',
  secondary: '#333333',
};

const READ_ONLY_ALPHA = 0.6;
const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      root: {
        marginBottom: '15px',
      },
    },
    MuiInput: {
      input: {
        '&::placeholder': {
          color: colors.primary,
          textTransform: 'none',
        },
        '&:read-only': {
          color: fade('#000000', READ_ONLY_ALPHA),
        },
      },
      underline: {
        '&$disabled:after': {
          borderBottomColor: 'transparent',
        },
        '&$disabled:before': {
          borderBottomColor: 'transparent',
        },
        '&$focused:after': {
          borderBottomColor: colors.earlsGreen,
        },
        '&$focused:before': {
          borderBottomColor: colors.earlsGreen,
        },
        '&:after': {
          borderBottomColor: colors.silver,
        },
        '&:before': {
          borderBottomColor: colors.silver,
        },
        '&:hover:not($disabled):not($focused):not($error):before': {
          borderBottomColor: colors.earlsGreen,
        },
      },
    },
    MuiInputLabel: {
      outlined: {
        '&$shrink': {
          marginBottom: '5px',
          transform: 'translate(0, 0) scale(0.75)',
        },
        position: 'static',
      },
    },
    MuiLinearProgress: {
      bar1Determinate: {
        background: colors.earlsGreen,
      },
      determinate: {
        background: colors.alto,
        height: '2px',
      },
    },
    MuiOutlinedInput: {
      input: {
        padding: '10px 14px 11px',
      },
      notchedOutline: {
        '& > legend': {
          display: 'none',
        },
        top: 0,
      },
      root: {
        '& $notchedOutline': {
          borderColor: colors.silver,
        },
        '&$focused $notchedOutline': {
          borderColor: colors.earlsGreen,
        },
        '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
          borderColor: colors.earlsGreen,
        },
      },
    },
  },
  palette: {
    primary: {
      main: colors.primary,
    },
    secondary: {
      main: colors.secondary,
    },
  },
  props: {
    MuiCard: {
      elevation: 0,
    },
    MuiPaper: {
      elevation: 0,
    },
  },
  typography: {
    body1: {
      color: colors.primary,
      fontSize: '14px',
      lineHeight: '21px',
    },
    fontFamily: ['SansOri', 'Arial', 'Helvetica', 'sans-serif'].join(','),
    fontSize: 14,
    h1: {
      color: colors.primary,
      fontSize: '35px',
      fontWeight: 'bold',
      lineHeight: '51px',
    },
    h2: {
      color: colors.primary,
      fontSize: '15px',
      fontWeight: 'bold',
      lineHeight: '22px',
      textTransform: 'uppercase',
    },
    htmlFontSize: 10,
  },
});

export { theme };
